import { render, staticRenderFns } from "./SuccessPurchaseView.vue?vue&type=template&id=b78c19ae"
import script from "./SuccessPurchaseView.vue?vue&type=script&lang=js"
export * from "./SuccessPurchaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports